//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from 'better-scroll'
import Loading from '../loading/loading.vue'
import Bubble from '../bubble/bubble.vue'

function getRect (el) {
  return {
    top: el.offsetTop,
    left: el.offsetLeft,
    width: el.offsetWidth,
    height: el.offsetHeight
  }
}

const camelizeRE = /-(\w)/g
function camelize (str) {
  str = String(str)
  return str.replace(camelizeRE, function (m, c) {
    return c ? c.toUpperCase() : ''
  })
}

const COMPONENT_NAME = 'td-scroll'
const DIRECTION_H = 'horizontal'
const DIRECTION_V = 'vertical'
const DEFAULT_REFRESH_TXT = '' // 下拉刷新成功后显示的文字
const DEFAULT_STOP_TIME = 600
const EVENT_SCROLL = 'scroll'
const EVENT_SCROLL_END = 'scroll-end'
const EVENT_BEFORE_SCROLL_START = 'before-scroll-start'
const EVENT_CLICK = 'click'
const EVENT_PULLING_DOWN = 'pulling-down'
const EVENT_PULLING_UP = 'pulling-up'
const NEST_MODE_NONE = 'none'
const NEST_MODE_NATIVE = 'native'
const SCROLL_EVENTS = [
  EVENT_SCROLL,
  EVENT_BEFORE_SCROLL_START,
  EVENT_SCROLL_END
]
const DEFAULT_OPTIONS = {
  observeDOM: true,
  click: true,
  probeType: 1,
  scrollbar: false,
  pullDownRefresh: false,
  pullUpLoad: false
}

export default {
  name: COMPONENT_NAME,
  provide () {
    return {
      parentScroll: this
    }
  },
  inject: {
    parentScroll: {
      default: null
    }
  },
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    scrollEvents: {
      type: Array,
      default () {
        return []
      },
      validator (arr) {
        return arr.every(item => {
          return SCROLL_EVENTS.indexOf(item) !== -1
        })
      }
    },
    options: {
      type: Object,
      default () {
        return {}
      }
    },
    listenScroll: {
      type: Boolean,
      default: undefined,
      deprecated: {
        replacedBy: 'scroll-events'
      }
    },
    listenBeforeScroll: {
      type: Boolean,
      default: undefined,
      deprecated: {
        replacedBy: 'scroll-events'
      }
    },
    listenScrollEnd: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: DIRECTION_V
    },
    refreshDelay: {
      type: Number,
      default: 20
    },
    nestMode: {
      type: String,
      default: NEST_MODE_NONE
    },
    listRef: {
      type: String,
      default: 'list'
    }
  },
  data () {
    return {
      beforePullDown: true,
      isRebounding: false,
      isPullingDown: false,
      isPullUpLoad: false,
      pullUpDirty: true,
      bubbleY: 0,
      pullDownStyle: '',
      pullDownStop: 40,
      pullDownHeight: 60
    }
  },
  computed: {
    pullDownRefresh () {
      let pullDownRefresh = this.options.pullDownRefresh
      if (!pullDownRefresh) {
        return pullDownRefresh
      }
      if (pullDownRefresh === true) {
        pullDownRefresh = {}
      }
      return Object.assign({ stop: this.pullDownStop }, pullDownRefresh)
    },
    pullUpLoad () {
      return this.options.pullUpLoad
    },

    pullUpTxt () {
      const pullUpLoad = this.pullUpLoad
      const txt = pullUpLoad && pullUpLoad.txt
      const moreTxt = (txt && txt.more) || ''
      const noMoreTxt = (txt && txt.noMore) || ''
      return this.pullUpDirty ? moreTxt : noMoreTxt
    },
    refreshTxt () {
      const pullDownRefresh = this.pullDownRefresh
      return (pullDownRefresh && pullDownRefresh.txt) || DEFAULT_REFRESH_TXT
    },
    finalScrollEvents () {
      const finalScrollEvents = this.scrollEvents.slice()
      if (!finalScrollEvents.length) {
        this.listenScroll && finalScrollEvents.push(EVENT_SCROLL)
        this.listenBeforeScroll &&
          finalScrollEvents.push(EVENT_BEFORE_SCROLL_START)
      }
      return finalScrollEvents
    },
    needListenScroll () {
      return (
        this.finalScrollEvents.indexOf(EVENT_SCROLL) !== -1 || this.parentScroll
      )
    }
  },
  watch: {
    data () {
      setTimeout(() => {
        this.forceUpdate(true)
      }, this.refreshDelay)
    },
    pullDownRefresh: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.scroll.openPullDown(newVal)
          if (!oldVal) {
            this._onPullDownRefresh()
            this._calculateMinHeight()
          }
        }
        if (!newVal && oldVal) {
          this.scroll.closePullDown()
          this._offPullDownRefresh()
          this._calculateMinHeight()
        }
      },
      deep: true
    },
    pullUpLoad: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.scroll.openPullUp(newVal)
          if (!oldVal) {
            this._onPullUpLoad()
            this._calculateMinHeight()
          }
        }
        if (!newVal && oldVal) {
          this.scroll.closePullUp()
          this._offPullUpLoad()
          this._calculateMinHeight()
        }
      },
      deep: true
    }
  },
  activated () {
    /* istanbul ignore next */
    this.enable()
  },
  deactivated () {
    /* istanbul ignore next */
    this.disable()
  },
  created () {
    this.pullDownInitTop = -50
  },
  mounted () {
    this.$nextTick(() => {
      this.initScroll()
    })
  },
  beforeDestroy () {
    this.destroy()
  },
  // destroyed() {
  //   this.$refs.scroll && this.$refs.scroll.destroy();
  // },
  methods: {
    initScroll () {
      if (!this.$refs.wrapper) {
        return
      }
      this._calculateMinHeight()

      let options = Object.assign(
        {},
        DEFAULT_OPTIONS,
        {
          scrollY: this.direction === DIRECTION_V,
          scrollX: this.direction === DIRECTION_H,
          probeType: this.needListenScroll ? 3 : 1
        },
        this.options
      )

      this.scroll = new BScroll(this.$refs.wrapper, options)
      this.parentScroll &&
        this.nestMode !== NEST_MODE_NONE &&
        this._handleNestScroll()
      this._listenScrollEvents()
      if (this.pullDownRefresh) {
        this._getPullDownEleHeight()
        this._onPullDownRefresh()
      }
      if (this.pullUpLoad) {
        this._onPullUpLoad()
      }
    },
    disable () {
      this.scroll && this.scroll.disable()
    },
    enable () {
      this.scroll && this.scroll.enable()
    },
    refresh () {
      this._calculateMinHeight()
      this.scroll && this.scroll.refresh()
    },
    destroy () {
      this.scroll && this.scroll.destroy()
      this.scroll = null
    },
    scrollTo () {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments)
    },
    scrollToElement () {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
    },
    clickItem (item) {
      this.$emit(EVENT_CLICK, item)
    },
    forceUpdate (dirty = false) {
      if (this.pullDownRefresh && this.isPullingDown) {
        this.isPullingDown = false
        this._reboundPullDown(() => {
          this._afterPullDown(dirty)
        })
      } else if (this.pullUpLoad && this.isPullUpLoad) {
        this.isPullUpLoad = false
        this.scroll.finishPullUp()
        this.pullUpDirty = dirty
        dirty && this.refresh()
      } else {
        dirty && this.refresh()
      }
    },
    resetPullUpTxt () {
      this.pullUpDirty = true
    },
    _listenScrollEvents () {
      this.finalScrollEvents.forEach((event) => {
        this.scroll.on(camelize(event), (...args) => {
          this.$emit(event, ...args)
        })
      })
    },
    _handleNestScroll () {
      // waiting scroll initial
      this.$nextTick(() => {
        const innerScroll = this.scroll
        const outerScroll = this.parentScroll.scroll
        const scrolls = [innerScroll, outerScroll]
        scrolls.forEach((scroll, index, arr) => {
          // scroll ended always enable them
          scroll.on('touchEnd', () => {
            outerScroll.enable()
            innerScroll.enable()
            // when inner scroll reaching boundary, we will disable inner scroll, so when 'touchend' event fire,
            // the inner scroll will not reset initiated within '_end' method in better-scroll.
            // then lead to inner and outer scrolls together when we touch and move on the outer scroll element,
            // so here we reset inner scroll's 'initiated' manually.
            innerScroll.initiated = false
          })
          scroll.on('beforeScrollStart', () => {
            this.touchStartMoment = true
            const anotherScroll = arr[(index + 1) % 2]
            anotherScroll.stop()
            anotherScroll.resetPosition()
          })
        })
        innerScroll.on('scroll', pos => {
          // if scroll event triggered not by touch event, such as by 'scrollTo' method
          if (!innerScroll.initiated || innerScroll.isInTransition) {
            return
          }
          if (this.nestMode === NEST_MODE_NATIVE && !this.touchStartMoment) {
            return
          }
          const reachBoundary = this._checkReachBoundary(pos)
          if (reachBoundary) {
            innerScroll.resetPosition()
            innerScroll.disable()
            // Prevent outer scroll have a bouncing step when enabled in 'free' nestMode.
            outerScroll.pointX = innerScroll.pointX
            outerScroll.pointY = innerScroll.pointY
            outerScroll.enable()
          } else {
            outerScroll.disable()
          }
          this.touchStartMoment = false
        })
      })
    },
    _checkReachBoundary (pos) {
      const distX = this.scroll.distX
      const distY = this.scroll.distY
      const reachBoundaryX =
        distX > 0
          ? pos.x >= this.scroll.minScrollX
          : distX < 0
            ? pos.x <= this.scroll.maxScrollX
            : false
      const reachBoundaryY =
        distY > 0
          ? pos.y >= this.scroll.minScrollY
          : distY < 0
            ? pos.y <= this.scroll.maxScrollY
            : false
      const freeScroll = this.scroll.freeScroll
      let reachBoundary
      if (freeScroll) {
        return reachBoundaryX || reachBoundaryY
      }
      if (this.scroll.movingDirectionX) {
        reachBoundary = reachBoundaryX
      } else if (this.scroll.movingDirectionY) {
        reachBoundary = reachBoundaryY
      }
      return reachBoundary
    },
    _calculateMinHeight () {
      if (this.$refs.listWrapper) {
        this.$refs.listWrapper.style.minHeight =
          this.pullDownRefresh || this.pullUpLoad
            ? `${getRect(this.$refs.wrapper).height + 1}px`
            : 0
      }
    },
    _onPullDownRefresh () {
      this.scroll.on('pullingDown', this._pullDownHandle)
      this.scroll.on('scroll', this._pullDownScrollHandle)
    },
    _offPullDownRefresh () {
      this.scroll.off('pullingDown', this._pullDownHandle)
      this.scroll.off('scroll', this._pullDownScrollHandle)
    },
    _pullDownHandle () {
      if (this.resetPullDownTimer) {
        clearTimeout(this.resetPullDownTimer)
      }
      this.beforePullDown = false
      this.isPullingDown = true
      this.$emit(EVENT_PULLING_DOWN)
    },
    _pullDownScrollHandle (pos) {
      if (this.beforePullDown) {
        this.bubbleY = Math.max(0, pos.y - this.pullDownHeight)
        this.pullDownStyle = `top:${Math.min(
          pos.y - this.pullDownHeight,
          0
        )}px`
      } else {
        this.bubbleY = 0
        this.pullDownStyle = `top:${Math.min(pos.y - this.pullDownStop, 0)}px`
      }
    },
    _onPullUpLoad () {
      this.scroll.on('pullingUp', this._pullUpHandle)
    },
    _offPullUpLoad () {
      this.scroll.off('pullingUp', this._pullUpHandle)
    },
    _pullUpHandle () {
      this.isPullUpLoad = true
      this.$emit(EVENT_PULLING_UP)
    },
    _reboundPullDown (next) {
      const { stopTime = DEFAULT_STOP_TIME } = this.pullDownRefresh
      setTimeout(() => {
        this.scroll.finishPullDown()
        next()
      }, stopTime)
    },
    _afterPullDown (dirty) {
      this.resetPullDownTimer = setTimeout(() => {
        this.pullDownStyle = `top: -${this.pullDownHeight}px`
        this.beforePullDown = true
        dirty && this.refresh()
      }, this.scroll.options.bounceTime)
    },
    _getPullDownEleHeight () {
      const pulldown = this.$refs.pulldown.firstChild
      this.pullDownHeight = getRect(pulldown).height
      this.beforePullDown = false
      this.isPullingDown = true
      this.$nextTick(() => {
        this.pullDownStop = getRect(pulldown).height
        this.beforePullDown = true
        this.isPullingDown = false
      })
    }
  },
  components: {
    Loading,
    Bubble
  }
}



// WEBPACK FOOTER //
// ./src/components/common/scroll/scroll.vue